// extracted by mini-css-extract-plugin
export default {"statistics":"XOvqR","welcome":"vfPBW","total":"XLId8","limit":"ItPAO","progressBar":"G23L1","icon":"Tja5u"};